<template>
  <modal
    transition="nice-modal-fade"
    width="560"
    height="auto"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    :name="modalName"
    class="listing--form-modal action--modal agent-notes-modal"
    @before-open="beforeOpen"
  >
    <div class="modal--wrapper">
      <section class="modal--container agent-notes-modal__container">
        <header class="agent-notes-modal__header">
          <span aria-hidden="true"></span>
          <h2 class="agent-notes-modal__title">{{ $t('listing.agentNotes') }}</h2>
          <button
            type="button"
            class="agent-notes-modal__close"
            aria-label="Tutup modal"
            @click="close"
          >
            <img src="@/assets/img/icons/close-1.svg" alt="" />
          </button>
        </header>
        <div v-if="listingTitle" class="agent-notes-modal__listing-title">
          {{ listingTitle }}
        </div>
        <div class="agent-notes-modal__content">{{ notes }}</div>
        <div class="agent-notes-modal__actions">
          <button type="button" class="btn btn-primary" @click="close">Tutup</button>
        </div>
      </section>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'agent-notes-modal',
  data() {
    return {
      modalName: 'agent-notes-modal',
      notes: '',
      listingTitle: '',
    };
  },
  methods: {
    beforeOpen(event) {
      const params = event.params || {};
      this.notes = typeof params.notes === 'string' ? params.notes.trim() : '';
      this.listingTitle = typeof params.listingTitle === 'string' ? params.listingTitle.trim() : '';
    },
    close() {
      this.$modal.hide(this.modalName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';

.agent-notes-modal__container {
  padding-top: 20px;
}

.agent-notes-modal__header {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) 32px;
  align-items: center;
}

.agent-notes-modal__title {
  margin: 0;
  color: $color-text-black;
  font-family: Poppins-Bold;
  font-size: 24px;
  text-align: center;
}

.agent-notes-modal__close {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }
}

.agent-notes-modal__listing-title {
  margin-top: 6px;
  overflow: hidden;
  color: $color-text-gray-2;
  font-size: $font-sm;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-notes-modal__content {
  max-height: 55vh;
  margin-top: 20px;
  padding: 14px 16px;
  overflow: auto;
  border: solid 1px $color-gray-1;
  border-radius: 12px;
  color: $color-text-black;
  font-size: $font-sm;
  line-height: 1.6;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.agent-notes-modal__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;

  .btn {
    min-width: 112px;
  }
}

@media #{$phones} {
  .agent-notes-modal__container {
    padding-top: 16px;
  }

  .agent-notes-modal__title {
    font-size: 20px;
  }

  .agent-notes-modal__content {
    max-height: 50vh;
    font-size: $font-xs;
  }

  .agent-notes-modal__actions .btn {
    width: 100%;
  }
}
</style>
